import $ from 'jquery';
window.$ = window.jQuery = $;

import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';

// Load jQuery-dependent plugins after jQuery is on window
(async () => {
  await import('bootstrap');
  await import('@fancyapps/fancybox');
  await import('slick-carousel');

  await import('./_fancybox.js');
  await import('./_slick-carousel.js');
  await import('./_navbar-fixed.js');
  await import('./_section-reveal.js');
  await import('./_smoothscroll.js');
  await import('./_console.js');
})();
